export enum Howfaraisle {
    Quarter = 1,
            Half = 2,
            ThreeQuarters = 3,
            EndCapFront = 4,
            EndCapBack = 5
}
